// Constants
import * as Constants from "../../constants";

// Helpers
import DB from "../../helpers/db";

import { LOGIN, LOADER } from "../definitions";
import { redirectToLoginPage, getCookie } from "../.././helpers/utils";

export const fetchLogin = () => async (dispatch) => {
  let getCidValue = "";
  let getUsernameValue = "";
  const cookieValue = getCookie("_e_p_u");
  if (cookieValue) {
    getCidValue = cookieValue.split("epuc").pop().split("?epuname")[0];
    getUsernameValue = cookieValue.split("epuname").pop().split("?epjtn")[0];
  }
  try {
    dispatch({
      type: LOGIN.START_FETCH,
    });
    dispatch(startloader());
    await DB({
      method: Constants.HTTP_POST,
      url: `/getentityuserinfo`,
      data: { userCid: getCidValue },
    }).then((response) => {
      if (response?.data?.statusCode === "98") {
        redirectToLoginPage();
      } else {
        dispatch(getuserprofilename(getUsernameValue, response?.data));
      }
      dispatch(endloader());
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: LOGIN.FAIL_FETCH,
      payload: error,
    });
    // dispatch(redirectToUNAuthrizePage());
  } finally {
    dispatch(endloader());
  }
};

export const getuserprofilename =
  (getUsernameValue, loginApiResponse) => async (dispatch) => {
    try {
      dispatch({
        type: LOGIN.START_FETCH,
      });
      dispatch(startloader());
      await DB({
        method: Constants.HTTP_POST,
        url: `/entityusername`,
        data: { fullName: getUsernameValue },
      }).then((response) => {
        if (response?.data?.statusCode === "98") {
          redirectToLoginPage();
        } else {
          loginApiResponse.data.profileName = response?.data?.data;
          dispatch(loginApiPayload(loginApiResponse));
        }
        dispatch(endloader());
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: LOGIN.FAIL_FETCH,
        payload: error,
      });
    } finally {
      dispatch(endloader());
    }
  };

export const startloader = () => async (dispatch) => {
  dispatch({
    type: LOADER.START_LOADER,
    payload: true,
  });
};

export const endloader = () => async (dispatch) => {
  dispatch({
    type: LOADER.END_LOADER,
    payload: false,
  });
};

export const loginApiPayload = (payload) => async (dispatch) => {
  dispatch({
    type: LOGIN.FINISH_FETCH,
    payload: payload,
  });
};
